@if (!useSummaryView) {
  @if (!field.hidden) {
    <div>
      <div class="leading-6 font-large text-lg col-start-1 col-span-2">{{ field.label | localize }}@if (field.minRows > 0) {
        *
      }</div>
      <div class="flex justify-end">
        @if (!field.readonly && !field.control.disabled) {
          <button mat-flat-button class="mt-2 mr-3" color="accent" (click)="addItem()"
            [disabled]="field.maxRows && field.maxRows <= field.embeddedForms?.length">
            <mat-icon class="icon-size-5 mr-2" svgIcon="mat_outline:add"></mat-icon>
            {{ 'addRow' | transloco }}
          </button>
        }
      </div>
      <div [ngClass]="{'error-panel': someRowHasError() || field.control.hasError('incorrect')}" class="flex flex-col justify-between mb-2 mt-4 border">
        <!-- Header -->
            <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] z-10 text-sm sticky top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary border-b
                        bg-gray-50 dark:bg-slate-900">
          @for (column of field.table.dtype.column; track column) {
            <div class="flex items-center">
              {{ column.caption | localize }}
            </div>
          }
        </div>
        <!-- Rows -->
        @if (field.embeddedForms.length > 0) {
          @for (row of field.embeddedForms; track row; let i = $index) {
                    <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b
                        cursor-pointer hover:bg-sky-100 dark:hover:bg-hover" (click)="editItem(row)">
              @for (column of field.table.dtype.column; track column; let isLast = $last) {
                <div class="flex justify-between items-center">
                  <dtype-item [field]="row.fields[column.name]" [useSummaryView]="true"></dtype-item>
                  @if (isLast) {
                    <button class="-my-4" mat-icon-button color="warn" (click)="removeItem($event, i)">
                      <mat-icon [svgIcon]="'mat_outline:delete'"></mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
          }
          <!-- Total -->
          @if (total) {
            <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b">
              @for (column of field.table.dtype.column; track column; let isFirst = $first) {
                <div class="flex items-center">
                  @if (isFirst) {
                    <span class="font-bold">{{ 'TOTAL' | transloco }}</span>
                  }
                  @if (getColumnTotal(column); as total) {
                    <p>{{ total }}</p>
                  }
                </div>
              }
            </div>
          }
        } @else {
          <p class="p-8 flex justify-center items-center">{{ 'noRows' | transloco }}</p>
        }
      </div>
      @if (required && (defaultRow || field.embeddedForms.length === 0)) {
        <div class="text-md text-warn leading-none font-medium">
          {{ 'errorRequiredField' | transloco }}
        </div>
      }
      @if (someRowHasError()) {
        <div [ngClass]="{'ml-4': editView}" class="text-md text-warn leading-none font-medium">
          {{ 'errorRowsInvalid' | transloco }}
        </div>
      }
      @if (field.control.hasError('incorrect')) {
        <div [ngClass]="{'ml-4': editView}" class="text-md text-warn leading-none font-medium">
          {{ 'errorMinRowsInvalid' | transloco }} {{field.minRows}}
        </div>
      }
    </div>
  }
}

